require('../datepicker/datepicker.css');
require('../position/position.css');
require('./popup.css');
module.exports = require('./index-nocss.js');



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/src/datepickerPopup/index.js
// module id = 621
// module chunks = 1